import { styled } from '@mui/material/styles';

export const TabBody = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
}));
